// Seleccionar todos los botones "Leer"
const summaryButtons = document.querySelectorAll('summary.button');

// Iterar sobre cada botón "Leer" y agregar eventos
summaryButtons.forEach((summaryButton, index) => {
  summaryButton.addEventListener('click', () => {
    const modalOverlay = document.querySelector(`.details-modal-overlay.post-${index + 1}`);
    const modal = document.querySelector(`.details-modal.post-${index + 1}`);
    
    modalOverlay.classList.add('open');
    modal.classList.add('open');
  });

  const closeButton = document.querySelector(`.details-modal.post-${index + 1} .details-modal-close`);
  closeButton.addEventListener('click', () => {
    const modalOverlay = document.querySelector(`.details-modal-overlay.post-${index + 1}`);
    const modal = document.querySelector(`.details-modal.post-${index + 1}`);
    
    modalOverlay.classList.remove('open');
    modal.classList.remove('open');
  });
});
